// Activity import states mapped to Pill tones. A committed month is settled,
// one ready for review is the work in front of you, and one still parsing is
// in flight.

export const importStatusTone = {
  DRAFT: 'neutral',
  READY: 'warn',
  COMMITTED: 'ok',
}

// The two sources of a line. Franchisee invoices are the everyday figure;
// customer bills are the admin-only FTFS side.
export const activitySourceTone = {
  FRANCHISEE_INVOICE: 'ok',
  CUSTOMER_BILL: 'neutral',
}
